import React, { forwardRef } from 'react';

const formatRating = (rating) => {
  if (rating == null) return '--';
  return Math.round(rating).toString();
};

const BoxpressdTopRatedStoryCard = forwardRef(
  (
    {
      title = 'COMMUNITY PICK',
      subtitle = 'Weekly Top Rated',
      cigarBrand = 'Kristoff',
      cigarName = 'Ligero Maduro',
      country = 'NICARAGUA',
      rating = 86,
      cigarImage,
      imageOffsetX = 0,
      imageOffsetY = 0,
      cigarImageWidth = 280,
      accentColor = '#d3a966',
      textColor = '#1f1b17',
      footerText = 'Based on user ratings.',
      strengthContent = null,
      logoSrc = '/static/media/logo-v2.7fdf5dae374bee09768d.png',
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        style={{
          width: 1080,
          height: 1920,
          position: 'relative',
          overflow: 'hidden',
          background: 'transparent',
          fontFamily: '"Georgia", "Times New Roman", serif',
          color: textColor,
          boxSizing: 'border-box',
        }}
      >
        {/* Border */}
        <div
          style={{
            position: 'absolute',
            top: 180,
            left: 65,
            right: 65,
            bottom: 230,
            border: `3px solid ${accentColor}`,
            boxSizing: 'border-box',
          }}
        />

        {/* Top heading */}
        <div
          style={{
            position: 'absolute',
            top: 154,
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(19, 21, 24, 0.92)',
            padding: '0 28px',
            fontSize: 36,
            letterSpacing: 2,
            color: accentColor,
            fontWeight: 500,
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </div>

        {/* Script subtitle */}
        <div
          style={{
            position: 'absolute',
            top: 256,
            left: 96,
            fontSize: 92,
            lineHeight: 1,
            color: accentColor,
            fontFamily: '"Great Vibes", cursive',
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}
        >
          {subtitle}
        </div>

        {/* Cigar info */}
        <div
          style={{
            position: 'absolute',
            top: 560,
            left: 100,
            width: 620,
          }}
        >
          <div
            style={{
              fontSize: 48,
              lineHeight: 1.06,
              fontWeight: 500,
              letterSpacing: -1,
              color: '#efefef',
            }}
          >
            {cigarBrand}
          </div>

          <div
            style={{
              fontSize: 84,
              lineHeight: 1.06,
              fontWeight: 500,
              letterSpacing: -1,
              color: '#efefef',
            }}
          >
            {cigarName}
          </div>

          <div
            style={{
              marginTop: 42,
              fontSize: 28,
              letterSpacing: 1,
              color: '#efefef',
              textTransform: 'uppercase',
              fontFamily: 'Arial, Helvetica, sans-serif',
            }}
          >
            {country}
          </div>
        </div>

        {/* Strength area */}
        <div
          style={{
            position: 'absolute',
            left: 100,
            top: 1335,
            width: 360,
            minHeight: 150,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {strengthContent}
        </div>

        {/* Rating box */}
        <div
          style={{
            position: 'absolute',
            left: 156,
            top: 1020,
            width: 210,
            height: 250,
            background: 'rgba(251, 250, 247, 0.96)',
            border: `2px solid rgba(31,27,23,0.35)`,
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '14px 18px',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              textAlign: 'center',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: 24,
              color: '#6d6258',
              textTransform: 'uppercase',
            }}
          >
            <div
              style={{
                borderBottom: `2px solid ${accentColor}`,
                paddingBottom: 8,
              }}
            >
              Rated
            </div>
          </div>

          <div
            style={{
              textAlign: 'center',
              fontSize: 110,
              lineHeight: 1,
              fontWeight: 700,
              fontFamily: 'Arial, Helvetica, sans-serif',
            }}
          >
            {formatRating(rating)}
          </div>

          <div
            style={{
              textAlign: 'center',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: 24,
              letterSpacing: 1,
              borderTop: `2px solid ${accentColor}`,
              paddingTop: 10,
              textTransform: 'uppercase',
            }}
          >
            BOXPRESSD
          </div>
        </div>

        {/* Cigar image */}
        {cigarImage ? (
          <div
            style={{
              position: 'absolute',
              right: 135 + imageOffsetX,
              bottom: 185 + imageOffsetY,
              width: 192,
              height: 1350,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'visible',
            }}
          >
            <img
              src={cigarImage}
              alt={cigarName}
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                filter: 'drop-shadow(0 18px 22px rgba(0,0,0,0.18))',
              }}
            />
          </div>
        ) : (
          <div
            style={{
              position: 'absolute',
              right: 90,
              top: 340,
              width: 180,
              height: 1100,
              borderRadius: 90,
              background:
                'linear-gradient(180deg, #6e432c 0%, #5b3623 35%, #4a2d1f 100%)',
              boxShadow: '0 18px 22px rgba(0,0,0,0.18)',
            }}
          />
        )}

        {/* Footer */}
        <div
          style={{
            position: 'absolute',
            display: 'flex',
            left: 50,
            right: 50,
            bottom: 100,
            fontSize: 28,
            color: '#efefef',
            alignItems: 'center',
          }}
        >
          <img
            src={logoSrc}
            alt="Boxpressd"
            crossOrigin="anonymous"
            style={{ marginRight: 162, width: 280, display: 'block' }}
          />
          {footerText}
        </div>
      </div>
    );
  }
);

export default BoxpressdTopRatedStoryCard;
